'use strict';

function cleanupText(str) {
  return str.replace(/[<>]/g, '_');
}

app.controller('mainController', ['getConfigurations', '$scope', '$location', '$anchorScroll', '$document', '$timeout', '$http', '$sce', '$cookieStore', 'translationService', '$routeParams', '$route', '$location_skip', function (getConfigurations, $scope, $location, $anchorScroll, $document, $timeout, $http, $sce, $cookieStore, translationService, $routeParams, $route, $location_skip) {
  $scope.config = {urls: {}};
  $scope.navbarVisible = document.body.offsetWidth > 768;
  $scope.dropdownVisible = false;
  $scope.current_year = new Date().getFullYear();
  $scope.setIteminLS = function (itemKey, itemVal) {
    if (itemVal === undefined) {
      localStorage.removeItem(itemKey);
    } else {
      localStorage.setItem(itemKey, itemVal);
    }
  };

  const langRe = /(\/en|\/ru|\/ua)/;
  const locationlang = langRe.exec($location.path());
  if (locationlang !== null) {
    $scope.selectedLanguage = locationlang[0].replace("/", "");
  } else if ($cookieStore.get('lang') !== undefined) {
    $scope.selectedLanguage = $cookieStore.get('lang');
  } else {
    const userIsSpeakingUkrainian = (navigator.languages || []).includes("uk");
    const browserLang = (navigator.language || navigator.userLanguage)
      .slice(0, 2)
      .replace("uk", "ua");

    $scope.selectedLanguage = userIsSpeakingUkrainian
      ? "ua"
      : ["en", "ua", "ru"].includes(browserLang)
        ? browserLang
        : "en";

  }

  $scope.translate = function (lang) {
    $scope.selectedLanguage = lang;
    translationService.getTranslation($scope, lang, $http);
    document.cookie = "lang=%22" + lang + "%22";
    const urllang = langRe.exec($location.path());

    if (urllang === null) {
      $timeout(function () {
        const new_location = "/" + lang + $location.path();
        $location_skip.skipReload().path(new_location);
      })
    } else {
      if (urllang[0] !== "/" + lang) {
        $timeout(function () {
          const new_location = $location.path().replace(langRe, "/" + lang);
          $location_skip.skipReload().path(new_location);
        })
      }
    }
  };
  $scope.translationCallback = function () {
    // empty function
  };
  $scope.redefineTranslationCallback = function (func) {
    $scope.translationCallback = func;
  };

  getConfigurations($scope, function () {
    $scope.translate($scope.selectedLanguage);
  });
  // ------------------
  $scope.isActiveLang = function (lang) {
    return lang === $scope.selectedLanguage;
  };
  $scope.isActive = function (route) {
    return ('/' + $scope.selectedLanguage + route) === $location.path() || route === $location.path();
  };
  $scope.toTheTop = function () {
    $document.scrollTop(0, 500);
  };
  $scope.SkipValidation = function (value) {
    return $sce.trustAsHtml(value);
  };
  $scope.trustAsHtml = function (value) {
    return $sce.trustAsHtml(value);
  };
  $scope.trustAsResourceUrl = function (value) {
    return $sce.trustAsResourceUrl(value);
  };
  $scope.getTrustedValue = function(value) {
    return $sce.valueOf(value);
  };
  $scope.dateView = function (date) {
    const monthes = {
      en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      ru: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"],
      ua: ["січня", "лютого", "березня", "квітня", "травня", "червня", "липня", "серпня", "вересня", "жовтня", "листопада", "грудня"]
    };
    const years = {
      en: "",
      ru: "г.",
      ua: "р."
    };
    date = date.split("-");
    const day = date['2'];
    const month = parseInt(date['1']) - 1;
    const year = date['0'];

    date = day + " " + monthes[$scope.selectedLanguage][month] + " " + year + years[$scope.selectedLanguage];
    return date;
  };

  angular.element(document).ready(function () {
    $timeout(function () {
      angular.element('footer').css({'visibility': 'visible'});
    }, 700);
    angular.element('.mail-text textarea').focus(function () {
      angular.element(this).css({'border': '2px solid white'});
    });
  });

  $scope.student = {
    name: '',
    surname: '',
    birthday: new Date('1995-12-31'),
    studyform: '',
    nickname: 'test',
    about: '',
    city: '',
    other_city: '',
    phone: '',
    parent_phone: '',
    parent_name: '',
    email: '',
    lessontime: '',
    hours: '',
    portfolio: '',
    find_out_about_shpp: '',
    job_change: 0,
    occupation: '',
    english: 'My name is Вова',
    photo: '',
    course: 'js-basics',
    experience: 'false'
  };

  $scope.submitError = {};

  $scope.checkIfNameAgeEmpty = function () {
    return $scope.student.name === '' || $scope.student.surname === '' || $scope.student.birthday === '';
  };
  $scope.dayPattern = /^0?[1-9]|[12]\d|3[01]$/;
  $scope.yearPattern = /^(19|20)\d{2}$/;
  $scope.agePattern = /^[0-9]+$/;
  $scope.birthdayPattern = /^(19\d{2}|20(0\d|1[1-5]))-[01]\d-[0123]\d$/;
  $scope.gmailPattern = /^.+@(gmail.com|kowo.me|programming.org.ua)$/;
  $scope.phonePattern = /^(\+?38)?[0-9\-\s\(\)]+$/; // +38 (050) 20-111-80
  $scope.skypePattern = /^[a-zA-Z][@\w.,\-]{5,31}$/;
  $scope.emailPattern = /^.+@[\w]+\.[\w]+$/;
  $scope.regAge = /^[\wа-яА-ЯёЁіІїЇєЄґҐ\s]+$/;
  $scope.cityPattern = /^[\wа-яА-ЯёЁіІїЇєЄґҐ\s\-,.]+$/;
  $scope.regComment = /^[\w'"?!()@:;.,\/+№а-яА-ЯёЁіІїЇєЄґҐ\s\-]*$/;
  $scope.namePattern = /^[\w'"а-яА-ЯёЁіІїЇєЄґҐ\-.,:]+/;
  $scope.surnamePattern = /^[\w'"а-яА-ЯёЁіІїЇєЄґҐ\-.,:]+/;
  $scope.textareaPattern = /^(?:['"?!()@:;.,\/+№а-яА-ЯёЁіІїЇєЄґҐ&#\\%=~-]|\w|\s)*$/u;

  $scope.hideNavbar = function() {
    if(document.body.offsetWidth > 768)
      return;
    $scope.navbarVisible = false;
  }
}]);

app.controller('home', ['$scope', '$timeout', '$http', '$location', '$routeParams', function ($scope, $timeout, $http) {
  $scope.redefineTranslationCallback(function () {
    // hack for this to be executed only for homepage
    if (location.pathname.length <= 3) {
      init();
    }
  });

  function init() {
    // kind of initialization
    $timeout(function () {
      getMainNews($scope, $http);
      getNearestAdultGroupStartDate($scope, $http);
      getFeedBacks($http, $scope, {feedbackType: 'random', count: 6}, () => {
        setTimeout(() => {
          $(".feedbacks-carousel").owlCarousel({
            dots: true,
            nav: true,
            loop: true,
            margin: 35,
            responsive: {
              0: {items: 1},
              768: {items: 3}
            }
          });
        }, 100);
      });
      $(".partners-carousel").owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 500,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
          0: {items: 1},
          600: {items: 3},
          1024: {items: 4},
          1200: {items: 5}
        }
      });
    });
  }

  setTimeout(init);

  $scope.getShppAge = (year, pattern) => getShppAge($scope.selectedLanguage, year, $scope.getTrustedValue(pattern));
}]);

app.controller('about', function ($scope, $location, $timeout, $http) {
  $scope.members = [];
  $http.get('./team.json').success(function (team) {
    $scope.members = team.filter(m => m.visible !== false).sort(() => Math.random() - 0.5);
    setTimeout(() => {
      $('.team-members-carousel').owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplaySpeed: 500,
        autoplayTimeout: 3000,
        nav: true,
        dots: false,
        responsive: {
          0: {items: 2},
          768: {items: 4},
          998: {items: 7}
        }
      });
    }, 100)
  });

  function initSlider() {
    $('.phil-slider').owlCarousel({
      loop: true,
      margin: 0,
      items: 1,
      responsive: {
        0: {
          autoplay: false
        },
        770: {
          autoplay: true,
          autoplaySpeed: 500,
          autoplayTimeout: 5000,
          autoplayHoverPause: true
        }
      }
    });
    $('.history-slider').owlCarousel({
      loop: false,
      items: 4,
      margin: 30,
      nav: true,
      dotsEach: 1,
      responsive: {
        0: {items: 1},
        768: {items: 3},
        990: {items: 4}
      }
    })
  }

  $timeout(initSlider, 500);
  // redefining function translate() from potential controller
  $scope.redefineTranslationCallback(function () {
    if ($location.$$path.match(/\/about/g)) {
      $timeout(function () {
        initSlider();
      })
    }
  })
});

app.controller('courses', function ($scope, $location) {
  angular.element(document).ready(function () {
    angular.element('.linkcontaining a').click(function () {
      const hash = angular.element(this).attr('href').replace("#", "");
      $location.hash(hash);
    });
  });
});

app.controller('feedbackForm', function ($scope) {
  $scope.redefineTranslationCallback(function () {
    changeFeedbackFormStructure($scope);
  });

  angular.element('#feedback-role').change(function () {
    changeFeedbackFormStructure($scope);
  });

  angular.element('#avatar').change(function () {
    angular.element('#avatar-btn').text($scope.translation.feedback_file_selected);
  });

  $scope.submitFeedback = function () {
    const feedbackBlock = document.getElementById('feedback');
    const feedbackForm = document.getElementById('feedback-form');
    const feedbackHead = document.getElementById('feedback-head');
    const submitButton = document.getElementById('feedback-submit');
    const feedbackError = document.getElementById('feedback-error');
    const formData = new FormData(feedbackForm);

    feedbackError.innerText = '';

    const xhr = new XMLHttpRequest();
    xhr.open('POST', $scope.config.urls.createFeedback);
    xhr.setRequestHeader('Authorization', 'Basic cm9tYW46MTIz');
    xhr.send(formData);

    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;

      if (xhr.status === 200) {
        feedbackForm.style.display = 'none';
        feedbackBlock.style.height = '80px';
        feedbackHead.style.textAlign = 'center';
        feedbackHead.innerText = $scope.translation.feedback_response_success;
        $scope.toTheTop();
      } else {
        submitButton.value = $scope.translation.feedback_submit;

        if (xhr.status === 418) {
          feedbackError.innerText = $scope.translation.feedback_response_error_418;
        }

        if (xhr.status === 500 || xhr.status === 400) {
          feedbackError.innerText = $scope.translation.feedback_response_error_500;
        }
      }
    };

    submitButton.value = $scope.translation.feedback_submiting;
  }
});

app.controller('feedbackAll', function ($scope, $http) {
  // i have no idea why it doesn't work without 0 timeout
  setTimeout(() => getFeedBacks($http, $scope, {feedbackType: 'student'}));

  $scope.redefineTranslationCallback(function () {
    getFeedBacks($http, $scope, {feedbackType: 'student'});
  });
});

app.controller('first', function ($scope, $location) {
  initStudentFields($scope);
  $scope.submitForm = (isValid) => submitFirstForm($scope, $location, isValid);
});

app.controller('check', function ($scope, $location) {
  if ($scope.checkIfNameAgeEmpty()) {
    $location.path("/" + $scope.selectedLanguage + '/anketa');
    return;
  }
  $scope.choose = function (page) {
    if (page !== 'choose') {
      // $scope.student.course = $scope.translation.schoolgroup;
      $scope.student.course = 'Школьная группа';
    }
    $location.path("/" + $scope.selectedLanguage + page);
  }
});

app.controller('course', function ($scope, $location) {
  if ($scope.checkIfNameAgeEmpty()) {
    $location.path("/" + $scope.selectedLanguage + '/anketa');
    return;
  }
  $scope.chooseCourse = function (c) {
    $scope.student.course = c;
    $location.path("/" + $scope.selectedLanguage + '/main');
  }
});

app.controller('main', function ($scope, $location, $http, FileUploader) {
  initStudentFields($scope);

  if ($scope.checkIfNameAgeEmpty()) {
    $location.path("/" + $scope.selectedLanguage + '/anketa');
    return;
  }

  const uploader = $scope.uploader = new FileUploader({
    url: $scope.config.urls.uploadStudentPhoto,
    formData: {email: $scope.student.email}
  });

  uploader.filters.push({
    name: 'imageFilter',
    fn: window.isImage
  });

  uploader.onSuccessItem = function () {
    // angular.element('.addImg').empty();
    angular.element('.thnx').show();
    // angular.element('.load-but').empty();
  };

  uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
    if (item.name.match(/\.heic$/)) {
      $scope.imageError = 'mf_photo_error_heic';
    } else {
      $scope.imageError = 'mf_photo_error';
    }
  };
  uploader.onAfterAddingFile = function (fileItem) {
    $scope.imageError = "";
  };

  $scope.controller = {
    isImage: window.isImage
  };

  $scope.submitForm = function (isValid) {
    $scope.submitError = {};
    var studentPost = JSON.parse(JSON.stringify($scope.student));

    if (uploader.queue[0] === undefined) {
      angular.element('html, body').animate({
        scrollTop: angular.element("#fileinp").first().offset().top// + 100
      }, 300);
      $scope.validated = true;
      $scope.submitted = false;

      return;
    }

    if (isValid) {
      studentPost.nickname = generateNickname(studentPost.name, studentPost.surname, $scope.selectedLanguage);

      studentPost.city = studentPost.city === 'other' ? studentPost.other_city : studentPost.city;
      //php like date
      studentPost.birthday = phpDate(studentPost.birthday);
      studentPost.about = cleanupText(studentPost.about);
      studentPost.experience = cleanupText(studentPost.experience);
      studentPost.find_out_about_shpp = cleanupText(studentPost.find_out_about_shpp);

      $http({
        method: 'POST',
        url: $scope.config.urls.createStudent,
        data: $.param({student: studentPost}),
        headers: getHttpHeaders()
      }).then(function successCallback({data: {data}} = {data: {data: {}}}) {
        window.dataLayer.push({
          'crm_id': data.userId,
          'user_id': data.userId,
          'event': 'eventIdSet',
        });
        // console.log(response);
        // fbq('trackCustom', 'registration-step-2', {
        //   age:  getAge($scope.student.birthday),
        //   fromAdultsLanding: localStorage.getItem('adultsLandingVisited') === '1'
        // });

        // gtag('config', 'G-TGRML89D55', {
        //   'user_id': data.userId
        // });
        // gtag('set', 'user_properties', {
        //   'crm_id': data.userId
        // });

        //add photo to this student

        uploader.queue[0].formData.email = data && data.email ? data.email : $scope.student.email;
        uploader.queue[0].upload();

        // todo check success uploading
        $location.path("/" + $scope.selectedLanguage + '/anketa/last');
        $scope.submitted = true;
        $scope.validated = false;
      }, function errorCallback({data: {data}, status} = {data: {data: {}}, status: null}) {
        $scope.submitError = {
          message: data.message || data.error.message,
          code: status
        };
        $scope.validated = false;
      });
    } else {
      $scope.validated = true;
      $scope.submitted = false;
      setTimeout(function () {
        angular.element('html, body').animate({
          scrollTop: angular.element(".has-error").first().offset().top - 100
        }, 300);
      })

    }
  }
});

app.controller('last', function ($scope, $http, $location) {
  $scope.student = {email: ''};
  initStudentFields($scope);
  if ($scope.checkIfNameAgeEmpty()) {
    $location.path("/" + $scope.selectedLanguage + '/anketa');
  } else {
    localStorage.clear();
  }
});

app.controller('supportus', function ($scope) {
  $scope.getShppAge = (year, pattern) => getShppAge($scope.selectedLanguage, year, $scope.getTrustedValue(pattern));
});

app.controller('adultsLanding', ['$scope', '$http', '$location', function ($scope, $http, $location) {
  localStorage.setItem('adultsLandingVisited', '1');
  $scope.members = [];

  function initFeedBacks() {
    getFeedBacks($http, $scope, {feedbackType: 'random', count: 5}, () => {
      setTimeout(() => {
        // TODO: recheck this
        $(".feedbacks-carousel").owlCarousel({
          // center: true,
          dots: true,
          nav: true,
          loop: true,
          margin: 35,
          responsive: {
            0: {items: 1},
            768: {items: 3}
          }
        });
      }, 500);
    });
  }

  $http.get('./team.json').success(function (team) {
    $scope.members = team.filter(m => m.roles.includes('adults-mentor') && m.visible !== false)
  });

  setTimeout(initFeedBacks);

  initStudentFields($scope);

  $scope.submitForm = (isValid) => submitFirstForm($scope, $location, isValid, true);
}]);

app.controller('askForm', ['getConfigurations', '$scope', '$http', function (getConfigurations, $scope, $http) {
  getConfigurations($scope);

  $scope.anketa = {
    name: '',
    age: '',
    phone: '',
    email: '',
    question: ''
  };

  $scope.submitted = false;

  $scope.sendForm = function (isValid) {
    if (isValid) {
      $http({
        method: 'POST',
        url: $scope.config.urls.saveQuestion,
        data: $.param($scope.anketa),
        headers: getHttpHeaders()
      });
      $('.ask form').hide();
    }

    return false;
  }
}]);

function getFeedBacks($http, $scope, {feedbackType, count = 4, onlyStudents = true}, callback) {
  $http({
    method: 'POST',
    url: $scope.config.urls.getFeedback,
    data: $.param({
      count,
      onlyStudents,
      feedbackType,
      lang: $scope.selectedLanguage,
    }),
    headers: getHttpHeaders()
  }).success(function ({data}) {
    $scope.feedbacks = data.feedbacks.map(f => Object.assign(f, {
      image: `${$scope.config.urls.feedbacksImages}/${f.image}`,
      short_message: f.message.slice(0, 300)
    })).sort((a, b) => b.short_message.length - a.short_message.length);
    if (callback)
      callback();
  });
}

function submitFirstForm($scope, $location, isValid, fromAdultsLanding = false) {
  if (isValid) {
    const age = getAge($scope.student.birthday);
    // if (age < 8) {
    //   $scope.yearError = true;
    //   $scope.kidsGroupsAreFilled = false;
    //   return false;
    // }
    // if (age < 10) {
    //   $scope.yearError = false;
    //   $scope.kidsGroupsAreFilled = true;
    //   return false;
    // }
    if (age < 12) {
      $scope.yearError = true;
      $scope.kidsGroupsAreFilled = false;
      return false;
    }
    fbq('trackCustom', 'registration-step-1', {age, fromAdultsLanding});
    if (age < 17) {
      $scope.student.course ='js-basics';
      $scope.setIteminLS('course', $scope.student.course);
      $location.path("/" + $scope.selectedLanguage + '/anketa/teens');
    } else {
      $scope.student.course = '';
      $scope.setIteminLS('course', '');
      $location.path("/" + $scope.selectedLanguage + '/anketa/adults');
    }
  } else {
    angular.element('html, body').animate({
      scrollTop: angular.element(".has-error").first().offset().top - 100
    }, 300);
  }
}

function initStudentFields($scope) {
  for (let line in $scope.student) {
    if ($scope.student.hasOwnProperty(line)) {
      if (localStorage.getItem(line) !== null) {
        $scope.student[line] = (line !== 'birthday')
          ? localStorage.getItem(line)
          : new Date(localStorage.getItem(line)); // phpDate ?

        if (line === 'other_city') {
          $scope.student.city = 'other';
        }
      }
    }
  }
}

function changeFeedbackFormStructure($scope) {
  const role = angular.element('#feedback-role');

  if (role.val() === 'company') {
    angular.element('#feedback-name-label').text($scope.translation.feedback_company_name);
    angular.element('#feedback-surname-label').hide();
    angular.element('#surname').prop('required', false);
    angular.element('#surname').hide();
    angular.element('#feedback-link-label').text($scope.translation.feedback_company_site);
    angular.element('#feedback-image-label').text($scope.translation.feedback_company_logo);
  } else if (role.val() === 'user') {
    angular.element('#feedback-name-label').text($scope.translation.ff_name);
    angular.element('#feedback-surname-label').show();
    angular.element('#surname').prop('required', true);
    angular.element('#surname').show();
    angular.element('#feedback-link-label').text($scope.translation.feedback_facebook);
    angular.element('#feedback-image-label').text($scope.translation.feedback_avatar);
  }
}

function getMainNews($scope, $http) {
  let lang = $scope.selectedLanguage === 'ru' ? 'ua' : $scope.selectedLanguage;
  $http({
    method: 'GET',
    url: `${$scope.config.urls.getNewsPreview}/${lang}/last3posts.json`,
  })
  .success(function (latestPosts) {
    $scope.news = latestPosts.last3posts;
  });
}

function getNearestAdultGroupStartDate($scope, $http) {
  $http({
    method: 'GET',
    url: $scope.config.urls.nearestStartDateUrl
  }).success(function (response) {
    if (response.data.nearestStartDate === null) {
      $scope.start_p2p_date = $scope.translation.home_courses_adults_start_default;
      return
    }
    let [day, month, year] = response.data.nearestStartDate.split('.');
    let dayFromAPI = new Date(year, month, day);
    if (dayFromAPI > new Date()) {
      $scope.start_p2p_date = response.data.nearestStartDate;
    } else {
      $scope.start_p2p_date = $scope.translation.home_courses_adults_start_default;
    }
  });
}

//transliterate world to a lower case string
function transliterateWordLC(word, lang) {

  let firstLiteraXchange = {};
  let xchange = {};
  //exchange litera at the beginning of words
  const firstLiteraXchangeUA = {"є": "ye", "ї": "yi", "й": "y", "ю": "yu", "я": "ya"};
  //exchange litera which is not at the beginning of words
  const xchangeUA = {
    "а": "a",
    "б": "b",
    "в": "v",
    "г": "h",
    "ґ": "g",
    "д": "d",
    "е": "e",
    "є": "ie",
    "ж": "zh",
    "з": "z",
    "зг": "zgh",
    "и": "y",
    "і": "i",
    "ї": "i",
    "й": "i",
    "к": "k",
    "л": "l",
    "м": "m",
    "н": "n",
    "о": "o",
    "п": "p",
    "р": "r",
    "с": "s",
    "т": "t",
    "у": "u",
    "ф": "f",
    "х": "kh",
    "ц": "ts",
    "ч": "ch",
    "ш": "sh",
    "щ": "shch",
    "ю": "iu",
    "я": "ia"
  };

  //exchange litera at the beginning of words
  const firstLiteraXchangeRU = {};
  //exchange litera which is not at the beginning of words
  const xchangeRU = {
    "а": "a",
    "б": "b",
    "в": "v",
    "г": "g",
    "д": "d",
    "е": "e",
    "ё": "e",
    "ж": "zh",
    "з": "z",
    "и": "i",
    "й": "i",
    "к": "k",
    "л": "l",
    "м": "m",
    "н": "n",
    "о": "o",
    "п": "p",
    "р": "r",
    "с": "s",
    "т": "t",
    "у": "u",
    "ф": "f",
    "х": "kh",
    "ц": "ts",
    "ч": "ch",
    "ш": "sh",
    "щ": "shch",
    "ы": "y",
    "э": "e",
    "ю": "iu",
    "я": "ia"
  };

  const arrayOfChar = word.split('');

  if (lang === 'ua') {
    firstLiteraXchange = firstLiteraXchangeUA;
    xchange = xchangeUA;
    while (arrayOfChar.indexOf("з") > -1 && arrayOfChar[arrayOfChar.indexOf('з') + 1] === "г") {
      const point = arrayOfChar.indexOf('з');
      const nextpoint = point + 1;
      arrayOfChar[point] = "зг";
      arrayOfChar.splice(nextpoint, 1);
    }
  } else {
    firstLiteraXchange = firstLiteraXchangeRU;
    xchange = xchangeRU;
  }

  return arrayOfChar.map(function (char, index) {
    if (index === 0) {
      return firstLiteraXchange[char] || xchange[char] || "";
    } else {
      return xchange[char] || "";
    }
  }).join('');
}

function generateNickname(name, surname, language) {
  surname = surname.toLowerCase();
  name = name.toLowerCase();
  let nickname = '';

  switch (language) {
    case 'ru':
    case 'ua':
      if (/[а-яА-ЯёЁіІїЇєЄґҐ]/i.test(name)) {
        if (/[ёЁ]/i.test(name)) {
          nickname = transliterateWordLC(name, 'ru').charAt(0) + transliterateWordLC(surname, 'ru');
        } else if (/[іІїЇєЄґҐ]/i.test(name)) {
          nickname = transliterateWordLC(name, 'ua').charAt(0) + transliterateWordLC(surname, 'ua');
        } else {
          nickname = transliterateWordLC(name, language).charAt(0) + transliterateWordLC(surname, language);
        }
      } else {
        nickname = name.charAt(0) + surname;
      }

      break;

    case 'en':
      if (/[a-zA-Z]/i.test(name)) {
        nickname = name.charAt(0) + surname;
      } else {
        if (/[ёЁ]/i.test(name)) {
          nickname = transliterateWordLC(name, 'ru').charAt(0) + transliterateWordLC(surname, 'ru');
        } else if (/[іІїЇєЄґҐ]/i.test(name)) {
          nickname = transliterateWordLC(name, 'ua').charAt(0) + transliterateWordLC(surname, 'ua');
        } else {
          nickname = transliterateWordLC(name, language).charAt(0) + transliterateWordLC(surname, language);
        }
      }
      break;

    default:
      nickname = name.charAt(0) + surname;
  }
  return nickname;
}

function getAge(birthday) {
  if (typeof birthday === 'string') {
    birthday = new Date(birthday)
  }
  const today = new Date();
  const diffMonth = today.getMonth() - birthday.getMonth();

  let age = today.getFullYear() - birthday.getFullYear();

  if (diffMonth < 0 || (diffMonth === 0 && today.getDate() < birthday.getDate())) {
    age--;
  }

  return age;
}

const inRange = (x, from, to) => x >= from && x <= to;

const addLeadingZero = (x) => x >= 10 ? x : '0' + x;

function getShppAge(lang, creationDate, pattern) {
  const tokens = {
    years1: {ru: "лет", ua: "років", en: "years"},
    years2: {ru: "год", ua: "рік", en: "year"},
    years3: {ru: "года", ua: "роки", en: "years"},
  };

  const [day, month, year] = creationDate.split('-');
  const schoolFoundationDate = new Date(year, month - 1, day);
  const ageDifMs = Date.now() - schoolFoundationDate;
  const ageDate = new Date(ageDifMs);
  const yearsNum = Math.abs(ageDate.getUTCFullYear() - 1970);

  const yearsStr = inRange(yearsNum, 5, 20)
    ? tokens.years1[lang]
    : yearsNum % 10 === 1
      ? tokens.years2[lang]
      : inRange(yearsNum % 10, 2, 4)
        ? tokens.years3[lang]
        : tokens.years1[lang];

  return (pattern || "")
    .replace("{{yearsNum}}", yearsNum)
    .replace("{{yearsStr}}", yearsStr)
}

function getHttpHeaders() {
  return {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

function phpDate(date) {
  if (typeof date === 'string')
    date = new Date(date);
  return date.getFullYear() + '-' + addLeadingZero(date.getMonth() + 1) + '-' + addLeadingZero(date.getDate());
}
